export const getFileType = (fileName) => {
    let type = ''
    if (!fileName) {
        return
    }
    const ext = fileName.substring(fileName.lastIndexOf('.'))

    switch (ext) {
    case '.png':
        type = 'image'
        break
    case '.jpg':
        type = 'image'
        break
    case '.gif':
        type = 'image'
        break
    case '.mp4':
        type = 'video'
        break
    default:
        break
    }
    return type
}

export const _isNumber = (val) => {
    return typeof val === 'number' && !isNaN(val)
}

export const getUrlParams = (url) => {
    let urlStr = url.split('?')[1]
    const urlSearchParams = new URLSearchParams(urlStr)
    const result = Object.fromEntries(urlSearchParams.entries())
    return result
}

export const eventHandler = {
    getEvent: function (event) {
        return event || window.event
    },
    addEvent: function (element, type, handler) {
        if (element.addEventListener) {
            element.addEventListener(type, handler, false)
        } else if (element.attachEvent) {
            element.attachEvent('on' + type, handler)
        } else {
            element['on' + type] = handler
        }
    },
    getWheelDelta: function (event) {
        console.log(event.wheelDelta)
        return event.wheelDelta ? event.wheelDelta : (-event.detail) * 40
    }
}

export const getUrlParam = (url, key) => {
    const queryString = decodeURIComponent(url || location.href).split('?')[1]
    const data = queryString ? queryString.split('&') : []
    const param = {}
    for (var i = 0; i < data.length; i++) {
        param[data[i].split('=')[0]] = data[i].split('=')[1]
    }
    if (key) {
        return param[key]
    }
    return param
}

export const getStoreByKey = (key1, key2) => {
    // key1: localStorage 中 key名
    // key2 : 待取值key名
    try {
        const info = JSON.parse(localStorage.getItem(key1))
        return info[key2]
    } catch (e) {
        return undefined
    }
}



// WEBPACK FOOTER //
// ./src/utils/index.js